<script lang="ts">
    import { mdiChevronUp } from "@mdi/js";
    import { Collection } from "sveltefire";
    import {
        Card,
        CardTitle,
        ListGroup,
        Divider,
        CardText,
        List,
        ListItem,
        Icon,
        ProgressCircular,
    } from "svelte-materialify/src";
    import EducationInfo from "./EducationInfo.svelte";

    let actives: boolean[];
    let educations: any[] = [];

    function generateData(event): void {
        educations = event.detail.data;
        actives = new Array(educations.length).fill(false);
    }
</script>

<Card outlined>
    <CardTitle class="remove-break">My Education</CardTitle>
    <Divider />
    <CardText>
        <Collection
            path={"educations"}
            traceId={"educationsRead"}
            query={(ref) => ref.orderBy("order", "asc")}
            on:data={(event) => generateData(event)}
        >
            <List>
                {#each educations as education, i}
                    <ListGroup bind:active={actives[i]}>
                        <span slot="activator" class="block-wrap remove-break"
                            >{education.degree}</span
                        >
                        <span slot="append">
                            <Icon
                                path={mdiChevronUp}
                                rotate={actives[i] ? 0 : 180}
                            />
                        </span>
                        <ListItem ripple="false"
                            ><EducationInfo {education} /></ListItem
                        >
                    </ListGroup>
                {/each}
            </List>
            <span slot="loading">
                <ProgressCircular indeterminate color="primary" /></span
            >
            <span slot="fallback">Error loading data</span>
        </Collection>
    </CardText>
</Card>
